import React from 'react';
import {Box} from '@mui/material';
import PropTypes from 'prop-types';
import RichEditor from './Shared/RichEditor';
import RichEditorResultText from './Shared/RichEditorResultText';

const AdditionalNotes = ({
                             index,
                             id,
                             description,
                             onChange,
                             isEditMode,
                             isFormArchived,
                             placeholderValues,
                             readOnly,
                             accessLevel
                         }) => {

    return (
        <Box>
            {isEditMode
                ? <Box sx={{maxWidth: '52vw', cursor: 'pointer'}}>
                    <RichEditor value={description} onChange={onChange} id={id} index={index} isEditMode={isEditMode}
                                isFormLive={isFormArchived} accessLevel={accessLevel}/>
                </Box>
                : <RichEditorResultText description={description} placeholderValues={placeholderValues}
                                        readonly={readOnly} enableValidation={false}/>
            }
        </Box>
    );
};

AdditionalNotes.propTypes = {
    id: PropTypes.string,
    description: PropTypes.string,
    index: PropTypes.number,
    onChange: PropTypes.func,
    isEditMode: PropTypes.bool,
    isFormArchived: PropTypes.bool,
    readOnly: PropTypes.bool,
    accessLevel: PropTypes.number,
    placeholderValues: PropTypes.object
};

export default AdditionalNotes;